import { render, staticRenderFns } from "./UploadNewImgHiddenInput.vue?vue&type=template&id=9f356d66"
import script from "./UploadNewImgHiddenInput.vue?vue&type=script&lang=js"
export * from "./UploadNewImgHiddenInput.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports